import React, { useEffect, useState } from "react";
import "../App.css"; // ✅ Ensure the correct path
import "./css/Form.css";
import "./css/Main.css";
import { RetellWebClient } from "retell-client-js-sdk";

const agentId = "agent_df0596da5d70e7cca669d4463d";

interface RegisterCallResponse {
  access_token: string;
}

const retellWebClient = new RetellWebClient();

const Home = () => {
  const [isCalling, setIsCalling] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Track loading state
  const [showForm, setShowForm] = useState(true); // Show form initially
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    customerType: "customer", // Default to "customer"
  });

  useEffect(() => {
    retellWebClient.on("call_started", () => {
      console.log("call started");
    });

    retellWebClient.on("call_ended", () => {
      console.log("call ended");
      setIsCalling(false);
      setIsLoading(false); // Reset loading state
    });

    retellWebClient.on("agent_start_talking", () => {
      console.log("agent_start_talking");
    });

    retellWebClient.on("agent_stop_talking", () => {
      console.log("agent_stop_talking");
    });

    retellWebClient.on("error", (error) => {
      console.error("An error occurred:", error);
      retellWebClient.stopCall();
      setIsCalling(false);
      setIsLoading(false); // Reset loading state on error
    });
  }, []);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Set loading state

    try {
      const registerCallResponse = await registerCall(agentId, formData);
      if (registerCallResponse.access_token) {
        await retellWebClient.startCall({
          callId: registerCallResponse.call_id, accessToken: registerCallResponse.access_token, transport: registerCallResponse.transport, iceServers: registerCallResponse.ice_servers,
        });
        setIsCalling(true);
        setShowForm(false); // Hide form after submission
      }
    } catch (error) {
      console.error("Error starting call:", error);
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  // Register call with the agent and pass form data
  async function registerCall(
    agentId: string,
    formData: { firstName: string; lastName: string; email: string; customerType: string },
  ): Promise<RegisterCallResponse> {
    try {
      const response = await fetch("https://demo.braincx.ai:8080/create-web-call", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          agent_id: agentId,
          retell_llm_dynamic_variables: {
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.email,
            customer_type: formData.customerType,
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (err) {
      console.error("Error registering call:", err);
      throw err;
    }
  }

  return (
    <div className="App">
      <header className="center">
        <div className="logo-div">
          <img className="logo-main" src="/images/logo-white.png" alt="BrainCX Logo" />
        </div>
        <div className="button-div"></div>
        <div className="icon-div">
          <div className="menu-icon">
            <i className="fa-solid fa-bars fa-lg"></i>
          </div>
        </div>
      </header>

      {/* 🔹 Fixed Content Layout */}
      <div className="content center">
        <h1 className="main-heading">Voice AI Experiences</h1>
        <p className="sub-heading">Emerging Technology Made Simple, Authentic, and Human</p>
        <p className="content-para">
          Let Voice AI answer your calls, schedule appointments, answer questions in any language, collect & organize
          information,<br />
          and integrate seamlessly with your systems – all through voice technology that feels genuine.
        </p>

        {/* 🔹 Wave Video Section (Always Visible) */}
        <div className="wave-section">
          <div className="main-button">
            <video className="video-back" autoPlay loop muted playsInline>
              <source src="/images/wave-ai.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>

      {/* 🔹 Popup Form */}
      {showForm && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h2>Welcome to BrainCX</h2>
            <p>Please provide your details to start the demo.</p>
            <form onSubmit={handleSubmit} className="form-container">
              <div className="form-group">
                <label htmlFor="firstName">First Name:</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name:</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="customerType">You are a:</label>
                <select
                  id="customerType"
                  name="customerType"
                  value={formData.customerType}
                  onChange={handleInputChange}
                  required
                >
                  <option value="customer">Customer</option>
                  <option value="partner">Partner</option>
                  <option value="investor">Investor</option>
                </select>
              </div>
              <button type="submit" className="btn-01" disabled={isLoading}>
                {isLoading ? "Starting Demo..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;